import { tv } from "tailwind-variants";

import { Select } from "@/ui";
import type { Option } from "@/utils";

const pageSizeSelectVariants = tv({
  base: "flex flex-row items-center gap-2 text-sm text-content-muted",
});

type PageSizeSelectProps = {
  className?: string;
  onChange: (size: number) => void;
  options: readonly number[];
  value: number;
};

export const PageSizeSelect = ({ className, onChange, options, value }: PageSizeSelectProps) => {
  const selectOptions: Option[] = options.map((size) => {
    return { label: String(size), value: size };
  });

  return (
    <div className={pageSizeSelectVariants({ className })}>
      <span>Rows per page</span>

      <Select
        aria-label="Rows per page"
        id="page-size"
        onChange={(event) => {
          onChange(Number(event.target.value));
        }}
        options={selectOptions}
        value={value}
        hideEmptyOption
      />
    </div>
  );
};
